<script setup lang="ts">
interface Props {
  img: string;
  name: string;
  role: string;
  body: string;
}

defineProps<Props>();
</script>

<template>
  <!-- 开放排版：无边框 / 无底色 / 无阴影 -->
  <figure class="relative w-[min(16.5rem,72vw)] shrink-0 px-4 md:w-[min(22rem,78vw)] md:px-6 lg:px-8">
    <blockquote class="text-[13px] leading-5 text-slate-600 md:text-[15px] md:leading-7">
      “{{ body }}”
    </blockquote>
    <figcaption class="mt-3 flex items-center gap-2.5 md:mt-5 md:gap-3">
      <img
        :src="img"
        class="size-7 rounded-full object-cover md:size-8"
        width="32"
        height="32"
        :alt="name"
        loading="lazy"
      />
      <div class="min-w-0">
        <p class="truncate text-[13px] font-semibold tracking-tight text-foreground md:text-sm">
          {{ name }}
        </p>
        <p class="truncate text-[11px] text-muted-foreground md:text-xs">
          {{ role }}
        </p>
      </div>
    </figcaption>
  </figure>
</template>
